import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, watch, ref, nextTick } from 'vue';
import { useSalesStore } from '@/store/sales';


export default /*@__PURE__*/_defineComponent({
  __name: 'RelatedSalesApplier',
  props: {
    modelValue: {},
    clientId: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const salesStore = useSalesStore();
const pendingSales = ref<any[]>([]);
const applied = ref<(number | string)[]>([]);
let syncing = false;

const headers = [
  { title: 'Folio Venta', value: 'folio' },
  { title: 'Monto venta', value: 'amount' },
  { title: 'Monto aplicado', value: 'applied' },
  { title: 'Monto abonado', value: 'paid' },
  { title: 'Saldo pendiente', value: 'balance' },
];

const currency = (val: number | undefined | null) => {
  const num = Number(val) || 0;
  return `$${num.toFixed(2)}`;
};

const getBalance = (sale: any, appliedVal: any) => {
  const basePaid = Number(sale?.attributes?.paid || 0);
  const saleAmount = Number(sale?.attributes?.amount || 0);
  const appliedNum = Number(appliedVal || 0);
  const newPaid = basePaid + appliedNum;
  return saleAmount - newPaid;
};

const syncFromModel = async () => {
  syncing = true;
  applied.value = pendingSales.value.map((sale) => {
    const match = props.modelValue?.find((m: any) => m.sale_id === sale.id);
    return match?.amount || 0;
  });
  await nextTick();
  syncing = false;
};

const emitChanges = () => {
  if (syncing) return;
  const payload = pendingSales.value.map((sale, idx) => ({
    sale_id: sale.id,
    amount: Number(applied.value[idx] || 0),
  }));
  emit('update:modelValue', payload);
};

const loadPendingSales = async () => {
  if (!props.clientId) {
    pendingSales.value = [];
    applied.value = [];
    emit('update:modelValue', []);
    return;
  }

  const params = {
    'filter[client_id]': props.clientId,
    'filter[status]': 'Pendiente',
  };
  const res = await salesStore.searchSales(params);
  pendingSales.value = res.data || res || [];
  syncFromModel();
};

watch(() => props.clientId, loadPendingSales, { immediate: true });

watch(applied, emitChanges, { deep: true });
watch(() => props.modelValue, syncFromModel, { deep: true });

onMounted(loadPendingSales);

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.clientId)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          type: "info",
          variant: "tonal",
          class: "mb-4"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Selecciona un cliente para cargar las ventas pendientes. ")
          ])),
          _: 1,
          __: [0]
        }))
      : (_openBlock(), _createBlock(_component_v_data_table, {
          key: 1,
          headers: headers,
          items: pendingSales.value,
          "items-per-page": 10,
          class: "elevation-0",
          "hide-default-footer": ""
        }, {
          "item.folio": _withCtx(({ item }) => [
            _createTextVNode(" #" + _toDisplayString(item?.id), 1)
          ]),
          "item.amount": _withCtx(({ item }) => [
            _createTextVNode(_toDisplayString(currency(item.attributes?.amount)), 1)
          ]),
          "item.applied": _withCtx(({ item, index }) => [
            _createVNode(_component_v_text_field, {
              modelValue: applied.value[index],
              "onUpdate:modelValue": ($event: any) => ((applied.value[index]) = $event),
              type: "number",
              density: "compact",
              variant: "solo-filled",
              "hide-details": "",
              style: {"max-width":"140px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          "item.paid": _withCtx(({ item }) => [
            _createTextVNode(_toDisplayString(currency(item.attributes?.paid || 0)), 1)
          ]),
          "item.balance": _withCtx(({ item, index }) => [
            _createTextVNode(_toDisplayString(currency(getBalance(item, applied.value[index]))), 1)
          ]),
          _: 1
        }, 8, ["items"]))
  ]))
}
}

})